import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Onboarding from "@/components/Onboarding";
import AuthScreen from "@/components/AuthScreen";
import Explorer from "@/components/Explorer";
import MyMaps from "@/components/MyMaps";
import PaymentResult from "@/components/PaymentResult";
import SharedMap from "@/components/SharedMap";

function MainGate() {
  const { user, checking } = useAuth();
  const [onboarded, setOnboarded] = useState(() => localStorage.getItem("fn_onboarded") === "1");
  const [showMaps, setShowMaps] = useState(false);
  const [seed, setSeed] = useState(null);
  const [explorerKey, setExplorerKey] = useState(0);

  const finishOnboarding = () => { localStorage.setItem("fn_onboarded", "1"); setOnboarded(true); };

  if (!onboarded) return <Onboarding onFinish={finishOnboarding} />;

  if (checking) {
    return (
      <div className="app-bg min-h-screen flex items-center justify-center">
        <Loader2 className="w-10 h-10 animate-spin text-purple-300" />
      </div>
    );
  }

  if (!user) return <AuthScreen />;

  if (showMaps) {
    return (
      <MyMaps
        onClose={() => setShowMaps(false)}
        onOpen={(data) => { setSeed(data); setExplorerKey((k) => k + 1); setShowMaps(false); }}
      />
    );
  }

  return <Explorer key={explorerKey} seed={seed} onOpenMaps={() => setShowMaps(true)} />;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster theme="dark" position="top-center" richColors />
          <Routes>
            <Route path="/payment/success" element={<PaymentResult />} />
            <Route path="/payment/cancel" element={<PaymentResult cancel />} />
            <Route path="/share/:shareId" element={<SharedMap />} />
            <Route path="*" element={<MainGate />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
